import React, { FC } from 'react';
import classNames from 'classnames';

import styles from './row.module.scss';

type Props = {
  className?: string;
  id?: string;
  dataTestId?: string;
  dataFullstory?: string;
};

export const Row: FC<Props> = ({
  children,
  className,
  id,
  dataTestId,
  dataFullstory,
}) => {
  const rowClass = classNames(styles.row, className);
  return (
    <div
      className={rowClass}
      id={id}
      data-test-id={dataTestId}
      data-full-story={dataFullstory}
    >
      {children}
    </div>
  );
};
